import * as types from "types/actions/event"
import API from "store/api"
import serialize from "store/serialize"

export const _setEvent = (event = {}) => ({
  type: types.EVENT_SET,
  event
})

export const _setEventStats = (stats = {}) => ({
  type: types.EVENT_SET_STATS,
  stats
})

export const _updateEventStats = (statName, number) => ({
  type: types.EVENT_UPDATE_STATS,
  statName,
  number
})

export const clearEvent = () => ({
  type: types.EVENT_CLEAR
})

export const _moveEventSponsors = () => ({
  type: types.EVENT_SPONSORS_MOVE
})

export const getEvent = eventUrl => {
  return dispatch => {
    return API.get(`/events/${eventUrl}`)
      .then(response => response.body)
      .then(data => {
        let event = data[0]
        event.sponsors = event.sponsors.map(sponsor => {
          sponsor = {
            ...sponsor,
            auctionCode: event.auction_code
          }
          return sponsor
        })
        return serialize("event", data[0]).then(response => {
          dispatch(_setEvent(response))
          return response
        })
      })
  }
}

export const getEventStats = (eventUrl, startAtZero = false) => {
  return dispatch => {
    return API.get(`/events/stats/${eventUrl}`)
      .then(response => response.body)
      .then(data => {
        return serialize("stat", data[0]).then(response => {
          if (startAtZero) {
            response = {
              ...response,
              bid_earnings: 0,
              donation_earnings: 0,
              donation_pledges: 0,
              fixed_purchase_earnings: 0,
              raffle_purchase_earnings: 0
            }
          }
          dispatch(_setEventStats(response))
          return response
        })
      })
  }
}

export const getEventDonations = eventId => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      API.get(`/donations/event/${eventId}`)
        .set("Content-Type", "application/json")
        .then(response => {
          if (!response.ok) {
            throw Error(response.statusText)
          }
          return response
        })
        .then(response => response.body)
        .then(data => {
          resolve(data)
        })
        .catch(err => {
          reject(err)
        })
    })
    return deferred
  }
}



// WEBPACK FOOTER //
// ./src/actions/event.js